'use strict';

require('./translate');